import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    width: 90px;
    padding-left: 20px;
    height: 58px;
    position: relative;
    display: flex;
    align-items: center;
    opacity: ${displayState?.translucid ? 0.5 : 1};

    ${!displayState?.disabled && css`
      &:hover {
        opacity: 1;
        transition: opacity .3s;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.09) inset;
      }
    `}
  `}
`;

export default Wrapper(template);
